import { Directive, effect, input, OnDestroy } from '@angular/core';
import { MatInput } from '@angular/material/input';

@Directive({
  selector: '[eiqAutoFocus]'
})
export class AutoFocusDirective implements OnDestroy {
  eiqAutoFocus = input<boolean>();

  private timeoutId: number | undefined;

  constructor(private matInput: MatInput) {
    effect(() => {
      if (this.eiqAutoFocus()) {
        this.timeoutId = window.setTimeout(() => {
          this.matInput.focus();
        }, 10);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.timeoutId !== undefined) {
      clearTimeout(this.timeoutId);
    }
  }
}
